import React from "react";

export default function CenterManagerTrainerList({ trainers }) {
  return <section className="data-table-wrap" id="trainers" data-testid="center-manager-trainer-list"><table><thead><tr><th>Trainer</th><th>Email</th><th>Training Center</th></tr></thead><tbody>{trainers.map((trainer) => <tr key={trainer.id}><td>{trainer.name}</td><td>{trainer.email}</td><td>{trainer.center_name || "Assigned center"}</td></tr>)}</tbody></table></section>;
}